import React, { useCallback, useContext, useEffect, useState } from 'react'
import { AuthContext } from '../context/AuthContext'
import {
    getAuthHeader,
    getLocalStorageItem,
    getLocalStorageSize,
    getPathAndQueryParams,
    objectLang,
    setErrorWindow,
    setLocalStorageItem,
    setPathBack
} from "../functions"
import { createBrowserHistory } from "history"
import { useHttp } from "../hooks/http.hook"
import config from "../config.json"
import { PathLineClass } from "../elements/PathLineClass"
import { LoaderClass } from "../elements/LoaderClass"
import { MainPageAuthClass } from "../components/MainPageAuthClass"
import { MainPageNotAuthClass } from "../components/MainPageNotAuthClass"

export const MainPage = () => {
    setLocalStorageItem('page', 'MainPage')
    setLocalStorageItem('modal', setErrorWindow('', 540))

    const history = createBrowserHistory()
    setPathBack(history.location.pathname)

    const auth = useContext(AuthContext)
    const { request } = useHttp()
    const [languages, setLanguages] = useState(objectLang().languages)
    const [linkMyLinks, setLinkMyLinks] = useState('/my-links')
    const [loading, setLoading] = useState(true)
    const [isAuth, setIsAuth] = useState(false)

    const checkUser = useCallback(async () => {
        let host = window.location.host === 'localhost:3000'
            ? config.localHost
            : config.onrender

        try {
            const data = await request(
                `${host}/api/user/check`,
                'GET',
                null,
                { Authorization: getAuthHeader(auth) }
            )

            if (data.code === 601) {
                setIsAuth(false)
                localStorage.removeItem('isAuthMainPage')
            } else {
                if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
                setIsAuth(true)
                setLocalStorageItem('isAuthMainPage', 'true')
            }

            const arrLang = data.languages.language
            const langObj = {}
            for (const key in arrLang) {
                langObj[arrLang[key].lang] = arrLang[key]
            }
            setLanguages(langObj)
            setLocalStorageItem('languagesMainPage', langObj)

            if (data.user) {
                setLinkMyLinks(data.user.rootFolder)
                setLocalStorageItem('linkMyLinksMainPage', data.user.rootFolder)
            }

        } catch (e) {
            console.error('checkUser failed:', e)
        } finally {
            setLoading(false)
        }
    }, [auth, request])

    useEffect(() => {
        setTimeout(() => {
            checkUser().then()
        }, 500)
    }, [checkUser])

    const l = objectLang().language.lang

    if (JSON.stringify(objectLang().languages) !== JSON.stringify(languages)) {
        setLocalStorageItem('languages', languages)
        setLocalStorageItem('language', languages[l])
    }

    const lang = objectLang().language
    const localStorageLang = lang.lang

    if (loading) {
        return <LoaderClass/>
    }

    getLocalStorageSize()

    if (isAuth) {
        if (auth.accessToken && !getLocalStorageItem('isChangedLang')) {
            if (auth.language !== localStorageLang) {
                for (const i in languages) {
                    if (i === auth.language) {
                        setLocalStorageItem('language', languages[i])
                    }
                }
                setLocalStorageItem('isChangedLang', 'true')
                window.location.replace(getPathAndQueryParams()) // Нельзя использовать navigate()
            }
        }
        return (
            <>
                <PathLineClass/>
                <MainPageAuthClass
                    lang={lang}
                    auth={auth}
                    currentLang={l}
                    linkMyLinks={linkMyLinks}
                />
            </>
        )
    } else {
        return (
            <>
                <MainPageNotAuthClass
                    lang={lang}
                    currentLang={l}
                />
            </>
        )
    }
}
